import RFButton from "@/components/RFButton";
import EmptyContainer from "@/containers/common/EmptyContainer";
import log2Sentry from "@/utils/log2Sentry";
import rfStore from "@/utils/rfStore";
import { useRouter } from "next/router";
import { useEffect } from "react";

export default function NotFound() {
  const router = useRouter()

  useEffect(() => {
    log2Sentry('page not found', 'warning', {
      path: router.asPath,
      rfState: rfStore.getRFState()
    })
  }, [])

  const handleClick = () => {
    router.push("/contact-us")
  };
  return (
    <div className="text-center">
     <EmptyContainer title='404 - Page Not Found' />
    <RFButton onClick={handleClick}>Contact Us</RFButton>
    </div>
  );
}
